import { useState } from "react";
import ReferenceForm from "./ReferenceForm";
import ReferenceLink from "./ReferenceLink";

/**
 * Picks a reference from the library for one value, with a link to open the
 * one picked and "+ New link" to add a missing one, which is picked at once.
 *
 * @param {object} props
 * @param {string} props.id the select's id, for its label
 * @param {string} props.label
 * @param {string} props.value the picked reference id, "" for none
 * @param {import("./referencesApi").GhgReference[]} props.references
 * @param {(referenceId: string) => void} props.onChange
 * @param {() => void} props.onReferencesChanged
 */
export default function ReferencePicker({ id, label, value, references, onChange, onReferencesChanged }) {
  const [creating, setCreating] = useState(false);
  const reference = references.find((candidate) => String(candidate.id) === value) || null;

  const created = (saved) => {
    setCreating(false);
    onChange(String(saved.id));
    onReferencesChanged();
  };

  return (
    <div className="gdb-field gdb-field--full">
      <label htmlFor={id}>{label}</label>
      <div className="gdb-reference-line">
        <select id={id} value={value} onChange={(e) => onChange(e.target.value)}>
          <option value="">No link yet</option>
          {references.map((candidate) => (
            <option key={candidate.id} value={String(candidate.id)}>
              {candidate.title}
              {candidate.note ? ` — ${candidate.note}` : ""}
            </option>
          ))}
        </select>
        <ReferenceLink reference={reference} label="open" />
        {creating ? null : (
          <button type="button" className="kgb-btn kgb-btn--quiet" onClick={() => setCreating(true)}>
            + New link
          </button>
        )}
      </div>
      {creating ? <ReferenceForm onSaved={created} onCancel={() => setCreating(false)} /> : null}
    </div>
  );
}
